import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

const useContactUnsubscribes = (reactQueryOptions?: UseQueryOptions<any, Error>) => {
    const path = CuredApiPaths.REPORT_CONTACTS_UNSUBSCRIBES;

    return useQuery('contacts-unsubscribes', path, reactQueryOptions);
};

export default useContactUnsubscribes;
